import React, { type ReactNode, useState } from 'react';
import { Button } from 'react-bootstrap';
import { TooltipElement } from '@soulhx/ui-common';
import { queueLocalActionEntryCreate } from '@soulhx/client-store';
import { DateTime } from 'luxon';

export interface IActionButton {
  id: string;
  children: ReactNode;
  toolTip?: string;
}
export const ActionButton = ({ id, children, toolTip }: IActionButton) => {
  const [buttonState, setButtonState] = useState<'success' | 'danger' | undefined>(undefined);

  return (
    <TooltipElement tooltip={toolTip}>
      <Button
        variant="outline-primary"
        aria-label={toolTip}
        className={buttonState === undefined ? 'border-0 bg-body' : `border-0 bg-${buttonState}-subtle`}
        onClick={async () => {
          try {
            await queueLocalActionEntryCreate(id, true, DateTime.now().toISO()!);
            setButtonState('success');
            setTimeout(() => setButtonState(undefined), 3_000);
          } catch {
            setButtonState('danger');
            setTimeout(() => setButtonState(undefined), 3_000);
          }
        }}
      >
        {children}
      </Button>
    </TooltipElement>
  );
};
